import React from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

import theme from 'theme'
import media from 'media'

// DUMB: this is just a styled UniversalLink...
import Link from 'components/Link'
import Brand from '@anvilco-pkg/ui/components/Brand'
// import PublicFooter from '@anvilco-pkg/ui/components/PublicFooter'
import PublicFooter from './FROMUIBottomFooter'

import {
  BLOG_SLUG,
  HELP_SLUG,
  FORMS_SLUG,
  ASK_ANVIL_SLUG,
  HTML_TO_PDF_CONVERTER_SLUG,
  MARKDOWN_TO_PDF_CONVERTER_SLUG,
} from 'consts'

const Footer = styled(Flex).attrs({
  as: 'footer',
})`
  flex-direction: column;
  justify-content: center;
  padding: 50px 20px 20px 20px;
  position: relative;
  font-size: 16px;

  ${media.tablet`
    max-width: ${theme.paperMaxWidth}px;
    margin: 0 auto;
  `}

  ${media.giant`
    padding-left: 50px;
    padding-right: 50px;
  `}
`

const TopContainer = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 0px;

  ${media.tablet`
    align-items: flex-end;
    flex-direction: row;
    justify-content: center;
  `}
`

const Nav = styled(Flex)`
  flex-direction: column;
  width: 100%;
  justify-content: space-between;

  a {
    font-weight: ${theme.fontWeights.thin};
    color: ${theme.colors.black};
  }

  ${media.desktop`
    flex-direction: row;
  `}
`

const StyledTitle = styled.div`
  color: ${theme.colors.black};
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: ${theme.fontWeights.bold};
`

const StyledLinkContainer = styled(Flex)`
  flex-direction: column;
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 20px;

  ${media.tablet`
    margin-bottom: 20px;
  `}

  ${media.desktop`
    margin-bottom: 44px;
  `}

  ${media.giant`
    padding: 10px;
    width: 100%;
  `}
`

const StyledLink = styled(Link)`
  padding-bottom: 12px;
  line-height: 1.2;
`

const TopBrand = styled(Link)`
  display: block;
  width: 110px;
  position: absolute;
  right: 0;
  top: 50px;

  ${media.desktop`
    display: none;
  `}
`

export default () => (
  <Footer>
    <TopContainer>
      <Nav>
        <StyledLinkContainer>
          <StyledTitle>Products</StyledTitle>
          <StyledLink to="/products/document-sdk/">Document SDK</StyledLink>
          <StyledLink to="/document-ai/">Document AI</StyledLink>
          <StyledLink to="/products/workflows/">Workflows</StyledLink>
          <StyledLink to="/products/webforms/">Webforms</StyledLink>
          <StyledLink to="/products/etch/">Etch E-Sign</StyledLink>
          <StyledLink to="/products/pdf-services/">PDF services</StyledLink>
          <StyledLink to="/products/pdf-filling-api/">
            PDF filling API
          </StyledLink>
          <StyledLink to="/products/pdf-generation-api/">
            PDF generation API
          </StyledLink>
          <StyledLink to={`/${HTML_TO_PDF_CONVERTER_SLUG}`}>
            HTML to PDF converter
          </StyledLink>
          <StyledLink to={`/${MARKDOWN_TO_PDF_CONVERTER_SLUG}`}>
            Markdown to PDF converter
          </StyledLink>
        </StyledLinkContainer>
        <StyledLinkContainer>
          <StyledTitle>Features</StyledTitle>
          <StyledLink to="/products/workflows/features/fundamental-features/">
            Fundamental
          </StyledLink>
          <StyledLink to="/products/workflows/features/style-your-document-flows/">
            Branding
          </StyledLink>
          <StyledLink to="/products/document-ai/features/">
            Document AI
          </StyledLink>
          <StyledLink to="/products/workflows/features/security-and-compliance/">
            Security & Compliance
          </StyledLink>
          <StyledLink to="/products/workflows/features/customer-support/">
            Customer support
          </StyledLink>
          <StyledLink to="/products/etch/features/">Etch E-sign</StyledLink>
          <StyledLink to="/products/pdf-services/features/">
            PDF Services
          </StyledLink>
          <StyledLink to="/products/workflows/features/">Workflows</StyledLink>
        </StyledLinkContainer>
        <StyledLinkContainer>
          <StyledTitle>Industries</StyledTitle>
          <StyledLink to="/solutions/insurance/">Insurance</StyledLink>
          <StyledLink to="/solutions/human-resources/">
            Human resources
          </StyledLink>
          <StyledLink to="/solutions/real-estate/">Real estate</StyledLink>
          <StyledLink to="/solutions/healthcare/">Healthcare</StyledLink>
          <StyledLink to="/solutions/finance/">Finance</StyledLink>
          <StyledLink to={`/${BLOG_SLUG}/customer-stories/`}>
            Customer stories
          </StyledLink>
        </StyledLinkContainer>
        <StyledLinkContainer>
          <StyledTitle>Resources</StyledTitle>
          <StyledLink to="/pricing/">Pricing</StyledLink>
          <StyledLink to={`/${FORMS_SLUG}/`}>Form library</StyledLink>
          <StyledLink to={`/${HELP_SLUG}/`}>Help center</StyledLink>
          <StyledLink to={`/${ASK_ANVIL_SLUG}/`}>Ask Anvil</StyledLink>
          <StyledLink to={`/${HELP_SLUG}/`}>Tutorials</StyledLink>
          <StyledLink to={`/${BLOG_SLUG}/`}>Blog</StyledLink>
          <StyledLink to="https://changelog.useanvil.com/en">
            Product updates
          </StyledLink>
          <StyledLink to="https://www.youtube.com/@useanvil/podcasts">
            Build vs. Buy podcast
          </StyledLink>
          <StyledLink to="/partners/solution-partners/">
            Solution Partners
          </StyledLink>
        </StyledLinkContainer>
        <StyledLinkContainer>
          <StyledTitle>Developers</StyledTitle>
          <StyledLink to="/docs/api/getting-started/">Get started</StyledLink>
          <StyledLink to="/docs/">API documentation</StyledLink>
          <StyledLink to="/docs/api/graphql/reference/">
            API Reference
          </StyledLink>
          <StyledLink to="/open-source/">Open Source</StyledLink>
          <StyledLink to={`/${BLOG_SLUG}/engineering/`}>
            Engineering Blog
          </StyledLink>
        </StyledLinkContainer>
        <StyledLinkContainer>
          <StyledTitle>Company</StyledTitle>
          <StyledLink to="/about/">About Us</StyledLink>
          <StyledLink to="/contact-sales/" target="_blank">
            Contact sales
          </StyledLink>
          <StyledLink to={`/${BLOG_SLUG}/company-news/`}>
            Company news
          </StyledLink>
          <StyledLink to="https://www.linkedin.com/company/anvil-foundry/">
            LinkedIn
          </StyledLink>
          <StyledLink to="https://www.youtube.com/@useanvil/">
            YouTube
          </StyledLink>
          <StyledLink to="/careers/" target="__blank">
            Careers
          </StyledLink>
          <StyledLink to="/terms-and-privacy/">Terms & policy</StyledLink>
        </StyledLinkContainer>
      </Nav>
      <TopBrand to="/">
        <Brand />
      </TopBrand>
    </TopContainer>
    <PublicFooter linkComponent={Link} />
  </Footer>
)
